import { render, staticRenderFns } from "./RejectBdoCard.vue?vue&type=template&id=5dd7854c&"
import script from "./RejectBdoCard.vue?vue&type=script&lang=js&"
export * from "./RejectBdoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports